
import {Component, Mixins, Prop} from "vue-property-decorator";
import ItemArrayManager from "@/components/common-inputs/ItemArrayManager.vue";
import FaizOranForm from "@/components/forms/FaizOranForm.vue";
import {FaizOranEntity} from "@/entity/FaizOranEntity";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {TakipEntity} from "@/entity/TakipEntity";

@Component({
  components: {
    DeleteDialog,
    FormDialog,
    FaizOranForm,
    ItemArrayManager,
  },
})
export default class FaizOranList extends Mixins(SimpleInputMixin) {
  @Prop({}) standart: any;
  @Prop() takipTarihi!: Date;
  @Prop() faizOranlari!: any;

  headers = [
    {value: "tarih", text: "Başlangıç Tarihi"},
    {value: "oran", text: "Oran %", sortable: false},
  ];

  mounted() {
    if (!this.standart) {
      this.headers.push({
        value: "actions",
        text: "İşlemler",
        sortable: false,
      });
    }
  }

  oranGoster(aylikMi: boolean, aylikOran: number, yillikOran: number) {
    let aylik = aylikOran.toString().replace(".", ",");
    let yillik = yillikOran.toString().replace(".", ",");
    return aylikMi ? "Aylık " + aylik : "Yıllık " + yillik;
  }

  load() {
    this.$emit("load");
  }

  onAdd(item: FaizOranEntity) {
    this.localValue.push(item);
    this.input();
    this.$emit('value', this.localValue);
  }

  onUpdate(item: FaizOranEntity, index: number) {
    let newArray = [...this.localValue];
    newArray[index] = item;
    this.localValue = newArray;
    this.input();
  }

  /** Faiz türünde en az bir oran kalmalı: FaizTuruForm sıfır oranla kaydetmeye izin
   *  vermiyor, son oranı silmek faiz türünü sessizce hesaplanamaz hale getirirdi. */
  get sonOranMi(): boolean {
    return !Array.isArray(this.localValue) || this.localValue.length <= 1;
  }

  /** Kayıtlı satır sunucudan da silinir; kaydedilmemiş satır yalnız yereldedir. */
  silmeAdresi(item: FaizOranEntity): string | null {
    return item.id != null ? "/api/v1/faiz-oran/" + item.id : null;
  }

  silinebilirMi(item: FaizOranEntity): boolean {
    if (this.sonOranMi) {
      return false;
    }
    return item.id == null || this.$helper.isAuthorized("faiz-turu-sil");
  }

  silmeTooltip(item: FaizOranEntity): string {
    if (this.sonOranMi) {
      return "Faiz türünde en az bir oran bulunmalıdır.";
    }
    if (item.id != null && !this.$helper.isAuthorized("faiz-turu-sil")) {
      return "Bu işlem için yetkiniz yok.";
    }
    return "Sil";
  }

  /** Satır DİZİ SIRASIYLA değil KİMLİKLE bulunur: tablo tarihe göre sıralandığı için
   *  slot'tan gelen index görünen sırayı taşır, localValue'daki sırayı değil. */
  onDelete(item: FaizOranEntity) {
    let index = this.localValue.indexOf(item);
    if (index === -1) {
      return;
    }
    this.localValue.splice(index, 1);
    this.input();
  }
}
